import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../config/config";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

// Create a baseQuery with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/reservations`, // 👈 sample jaisa
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

export const GetReservationsSlice = createApi({
  reducerPath: "GetReservationsSlice",
  baseQuery,
  tagTypes: ["reservations"], // 👈 lowercase consistent
  endpoints: (builder) => ({
    // GET all reservations
    getAllReservations: builder.query({
      query: ({
        page = 1,
        limit = 10,
        status,
        search,
        start_date,
        end_date,
        booking_type,
      }) => {
        const params = new URLSearchParams();

        params.append("page", page);
        params.append("limit", limit);
        if (status) params.append("status", status);
        if (search) params.append("search", search);
        if (start_date) params.append("start_date", start_date); // ✅ NEW
        if (end_date) params.append("end_date", end_date);
        if (booking_type) params.append("booking_type", booking_type);

        // 👇 sample jaisa dynamic endpoint style
        return `all?${params.toString()}`;
      },
      providesTags: ["reservations"],
    }),
  }),
});

export const { useGetAllReservationsQuery } = GetReservationsSlice;
